<template>
  <n-config-provider :theme="theme" :theme-overrides="themeOverrides">
    <n-global-style />
    <n-loading-bar-provider>
      <n-dialog-provider>
        <n-notification-provider>
          <n-message-provider>
            <router-view v-slot="{ Component, route }">
              <!-- Use AppShell for authenticated routes -->
              <AppShell v-if="shouldUseAppShell(route)">
                <component :is="Component" />
              </AppShell>
              <!-- Use plain component for auth pages -->
              <component v-else :is="Component" />
            </router-view>
            <!-- Toast Personalizado com Tailwind -->
            <Toast />
          </n-message-provider>
        </n-notification-provider>
      </n-dialog-provider>
    </n-loading-bar-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { GlobalThemeOverrides } from 'naive-ui'
import Toast from '@/components/Toast.vue'
import AppShell from '@/components/AppShell.vue'

// Tema sempre claro
const theme = computed(() => null)

// Theme overrides com cores PDCA
const themeOverrides: GlobalThemeOverrides = {
  common: {
    primaryColor: '#30267E',
    primaryColorHover: '#2B2373',
    primaryColorPressed: '#251F68',
    borderRadius: '8px',
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
  },
  Button: {
    borderRadius: '8px',
    fontWeight: '500'
  },
  Card: {
    borderRadius: '12px'
  },
  Input: {
    borderRadius: '8px'
  },
  // Removido - usando Toast personalizado com Tailwind
}

// Determine if route should use AppShell
function shouldUseAppShell(route: any): boolean {
  const standalonePages = ['Login', 'AceitarConvite', 'RedefinirSenha', 'Contato', 'Manutencao', 'NotFound']
  const standalonePaths = ['/login', '/aceitar-convite', '/redefinir-senha', '/contato', '/manutencao']

  // Verificar por nome da rota ou por path
  return !standalonePages.includes(route.name) && !standalonePaths.includes(route.path)
}
</script>